import { useGetBlockReasons } from '../api/get-block-reasons';

function useBlockReasons() {
  const { data: reasons, isLoading } = useGetBlockReasons({
    staleTime: Infinity,
  });

  const reasonsOptions = reasons?.map((reason, index) => ({
    key: index,
    text: reason,
    value: reason,
  }));

  return { reasons, reasonsOptions, isLoading };
}

export default useBlockReasons;
